import React, { useEffect, useState } from "react";

export default function CubeGrabZone({ children, storageKey }) {
  const [grabbing, setGrabbing] = useState(false);

  const [showHint, setShowHint] = useState(() => {
    if (!storageKey) return true;
    return sessionStorage.getItem(storageKey) !== "1";
  });

  const dismiss = () => {
    if (!showHint) return;
    if (storageKey) sessionStorage.setItem(storageKey, "1");
    setShowHint(false);
  };

  // Auto-hide au bout de quelques secondes (optionnel mais agréable)
  useEffect(() => {
    if (!showHint) return;
    const t = setTimeout(() => setShowHint(false), 4500);
    return () => clearTimeout(t);
  }, [showHint]);

  return (
    <div
      className={[
        "relative select-none rounded-xl overflow-hidden",
        grabbing ? "cursor-grabbing" : "cursor-grab",
        // force le curseur sur tout ce qui est dans le canvas (important)
        "[&_*]:cursor-grab",
      ].join(" ")}
      onPointerDown={() => {
        setGrabbing(true);
        dismiss();
      }}
      onPointerUp={() => setGrabbing(false)}
      onPointerCancel={() => setGrabbing(false)}
      onMouseLeave={() => setGrabbing(false)}
      onClick={dismiss}
    >
      {children}

      {/* Indicateur discret */}
      {showHint && (
        <div className="pointer-events-none absolute inset-0">
          {/* petit badge */}
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full border border-white/15 bg-black/50 px-3 py-1 text-[11px] text-white/85 animate-pulse">
            Glissez pour tourner
          </div>

          {/* mini icône “drag” */}
          <div className="absolute top-3 right-3 rounded-full border border-white/15 bg-black/40 px-2 py-1 text-[11px] text-white/80">
            ✋↔
          </div>
        </div>
      )}
    </div>
  );
}
